<template>
  <div>
    <div class="searchHearder">
      <el-input clearable placeholder="请输入供应商名称" v-model="userParams.supplierName" />
      <el-input clearable placeholder="请输入供应商编码" v-model="userParams.supplierCode" />
      <el-select placeholder="请选择所属价格区域" v-model="userParams.priceRegion">
        <el-option v-for="item in priceRegionList" :key="item.priceRegionCode" :label="item.priceRegionName" :value="item.priceRegionId"></el-option>
      </el-select>
      <el-input clearable placeholder="请输入账号" v-model="userParams.loginAccount" />
      <el-input clearable placeholder="请输入姓名" v-model="userParams.userName" />
    </div>
    <div class="search-row">
      <div>
        <el-input clearable placeholder="请输入电话" v-model="userParams.workPhone" />
        <el-button class="btn-red-plain" size="small" @click="handleFilter">搜索</el-button>
        <el-button class="btn-red-plain" size="small" @click="handleReset">重置</el-button>
      </div>
      <el-button class="btn-red-plain" size="small" @click="handleCreate">+新建</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'search-row',
  data () {
    return {
      priceRegionList: [],
      userParams: {
        supplierName: '',
        supplierCode: '',
        priceRegion: '',
        loginAccount: '',
        userName: '',
        workPhone: '',
        page: 1,
        pageSize: 10
      }
    }
  },
  mounted () {
    this.getPriceRegion()
  },
  methods: {
    setUserParams (val) {
      this.userParams = val
    },
    // 搜索
    handleFilter () {
      this.$emit('onFilter', this.userParams)
    },
    handleReset () {
      this.userParams = this.$options.data().userParams
      this.$emit('onHandleReset')
    },
    // 新建
    handleCreate () {
      this.$router.push({
        path: '/bcc/user/info',
        query: {
          type: 'create'
        }
      })
    },
    async getPriceRegion () {
      const { data } = await this.$store.dispatch('getPriceRegion')
      if (data.resultCode === '0') {
        this.priceRegionList = data.resultData?.priceRegionList || []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.searchHearder {
  margin-bottom: 12px;
}
.search-row {
  display: flex;
  justify-content: space-between;
}
.el-input,
.el-select {
  width: 230px;
  margin-right: 10px;
}
</style>
